import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLoginUserMutation } from "../../service/userApi";
import { UserContext } from "../../App";

const Login = () => {
  const [email, setEmail] = useState("");
  const { user, setUser } = useContext(UserContext);
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loginUser] = useLoginUserMutation();
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    const data = {
      email,
      password,
    };
    if (email && password) {
      loginUser(data).then((res) => {
        if (res?.data?.status) {
          if (res?.data?.data?.role === "admin") {
            localStorage.setItem("token", res?.data?.token);
            setUser(res?.data?.data);
            navigate("/dashboard");
          }
        } else {
          setError(res?.data.message);
        }
      });
    } else {
      setError("Please fill all the fields!");
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#1A202C",
      }}
    >
      <div
        style={{
          padding: "20px",
          border: "1px solid #4A5568",
          borderRadius: "5px",
          backgroundColor: "#2D3748",
          color: "white",
          maxWidth: "400px",
          width: "100%",
        }}
      >
        <h2 style={{ textAlign: "center", color: "white" }}>Login</h2>
        {error && (
          <p style={{ color: "#F56565", textAlign: "center" }}>{error}</p>
        )}
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: "10px", textAlign: "left" }}>
            <label>Email:</label>
            <input
              type="text"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={{
                width: "100%",
                padding: "8px",
                marginTop: "5px",
                borderRadius: "5px",
                color: "black",
              }}
            />
          </div>
          <div style={{ marginBottom: "10px", textAlign: "left" }}>
            <label>Password:</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{
                width: "100%",
                padding: "8px",
                marginTop: "5px",
                borderRadius: "5px",
                color: "black",
              }}
            />
          </div>
          <div style={{ textAlign: "center" }}>
            <button
              type="submit"
              style={{
                width: "100%",
                padding: "10px 0",
                border: "none",
                borderRadius: "5px",
                backgroundColor: "#007BFF",
                color: "white",
                cursor: "pointer",
              }}
            >
              Login
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
